import IAction from "../../models/IAction";
import BaseReducer from "../../utilities/BaseReducer";
import LookUpAction from "./LookUpAction";
import AdminisrativeCategoryModel from "./models/AdminisrativeCategoryModel";
import CanaliModel from "./models/CanaliModel";
import ConvenzioniModel from "./models/ConvenzioniModel";
import DurataModel from "./models/DurataModel";
import ILookUpState from "./models/ILookUpState";
import LookupManagementModel from "./models/LookupManagementModel";
import PrivacyInpsModel from "./models/PrivacyInpsModel";
import ProdottiModel from "./models/ProdottiModel";
import SegmentiModel from "./models/SegmentiModel";
import TipoSimulazioneModel from "./models/TipoRichiestaModel";
import SessoModel from "../simulazione/models/SessoModel";
import EstinzioniModel from "../simulazione/models/EstinzioniModel";
import NazioniModel from "stores/simulazione/models/NazioniModel";
import DocumentTypeModel from "./models/DocumentTypeModel";
import AuthorityTypeModel from "./models/AuthorityTypeModel";
import ComuniModel from "stores/simulazione/models/ComuniModel";
import TipoProdottoModel from "./models/TipoProdottoModel";
import AgentiProvvModel from "./models/AgentiProvvModel";
import SubLevelsModel from "./models/SubLevelsModel";
import TipologiaPraticaModel from "./models/TipologiaPraticaModel";
import environment from "environment";
import LookUpModel from "./models/LookUpModel";

export default class LookUpReducer extends BaseReducer<ILookUpState> {
    public tipologiePratica() {
        let tipologie =
            environment.tenant !== "Bpp"
                ? [
                      {
                          key: "0",
                          value: "Nuovo Cliente",
                      },
                      {
                          key: "1",
                          value: "Rinnovo",
                      },
                      {
                          key: "2",
                          value: "Coesistenza",
                      },
                      {
                          key: "3",
                          value: "Estinzione Terzi",
                      },
                  ]
                : [
                      {
                          key: "1",
                          value: "Estinzione a terzi",
                      },
                      {
                          key: "2",
                          value: "Pratica dipendente ente tesoreria",
                      },
                      {
                          key: "3",
                          value: "Rinnovo",
                      },
                      {
                          key: "4",
                          value: "Nuova operazione",
                      },
                  ];
        return tipologie;
    }

    public readonly initialState: ILookUpState = {
        tipiRichieste: [
            {
                key: "1",
                value: "CQS",
            },
            {
                key: "2",
                value: "CQP",
            },
            {
                key: "3",
                value: "DLG",
            },
        ] as TipoSimulazioneModel[],
        administrativeCategory: [],
        requestedType: [],
        management: [],
        durata: [
            {
                key: "24",
                value: "24",
            },
            {
                key: "36",
                value: "36",
            },
            {
                key: "48",
                value: "48",
            },
            {
                key: "60",
                value: "60",
            },
            {
                key: "72",
                value: "72",
            },
            {
                key: "84",
                value: "84",
            },
            {
                key: "96",
                value: "96",
            },
            {
                key: "108",
                value: "108",
            },
            {
                key: "120",
                value: "120",
            },
        ] as DurataModel[],
        canali: [],
        segmenti: [],
        tipologiePratica: this.tipologiePratica() as TipologiaPraticaModel[],
        agentiProvv: [],
        prodotti: [],
        privacyInps: [
            {
                key: "1",
                value: "No",
            },
            {
                key: "2",
                value: "Si",
            },
        ] as PrivacyInpsModel[],
        convenzioni: [],
        sesso: [
            {
                key: "M",
                value: "M",
            },
            {
                key: "F",
                value: "F",
            },
        ] as SessoModel[],
        estinzioni: [
            {
                key: "1",
                value: "Si",
            },
            {
                key: "2",
                value: "No",
            },
        ] as EstinzioniModel[],
        nazioni: [],
        comuniBirthPlace: [],
        comuniResidencePlace: [],
        documentTypes: [],
        authorityTypes: [],
        productTypes: [],
        addressTypes: [],
        subLevels: [],
        filiali: [],
        segnalazioni: [],
        motivCambioTan: [],
        statoPrev: [],
    };

    public [LookUpAction.REQUEST_LOOKUP_ADMINISTRATIVE_CATEGORY_GET_FINISHED](
        state: ILookUpState,
        action: IAction<AdminisrativeCategoryModel[]>
    ): ILookUpState {
        return {
            ...state,
            administrativeCategory: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_LOOKUP_REQUESTED_TYPE_GET_FINISHED](
        state: ILookUpState,
        action: IAction<AdminisrativeCategoryModel[]>
    ): ILookUpState {
        return {
            ...state,
            requestedType: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_LOOKUP_MANAGEMENT_GET_FINISHED](
        state: ILookUpState,
        action: IAction<LookupManagementModel[]>
    ): ILookUpState {
        return {
            ...state,
            management: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_LOOKUP_CANALI_GET_FINISHED](
        state: ILookUpState,
        action: IAction<CanaliModel[]>
    ): ILookUpState {
        return {
            ...state,
            canali: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_LOOKUP_CANALI_GET_RESET](
        state: ILookUpState,
        action: IAction<CanaliModel[]>
    ): ILookUpState {
        return {
            ...state,
            canali: this.initialState.canali,
        };
    }

    public [LookUpAction.REQUEST_LOOKUP_AGENTIPROVV_GET_FINISHED](
        state: ILookUpState,
        action: IAction<AgentiProvvModel[]>
    ): ILookUpState {
        return {
            ...state,
            agentiProvv: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_LOOKUP_SEGMENTI_GET_FINISHED](
        state: ILookUpState,
        action: IAction<SegmentiModel[]>
    ): ILookUpState {
        return {
            ...state,
            segmenti: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_LOOKUP_PRODOTTI_GET_FINISHED](
        state: ILookUpState,
        action: IAction<ProdottiModel[]>
    ): ILookUpState {
        return {
            ...state,
            prodotti: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_LOOKUP_CONVENZIONI_GET_FINISHED](
        state: ILookUpState,
        action: IAction<ConvenzioniModel[]>
    ): ILookUpState {
        return {
            ...state,
            convenzioni: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_LOOKUP_DOCUMENT_TYPES_GET_FINISHED](
        state: ILookUpState,
        action: IAction<DocumentTypeModel[]>
    ): ILookUpState {
        return {
            ...state,
            documentTypes: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_LOOKUP_AUTHORITY_TYPES_GET_FINISHED](
        state: ILookUpState,
        action: IAction<AuthorityTypeModel[]>
    ): ILookUpState {
        return {
            ...state,
            authorityTypes: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_LOOKUP_NAZIONI_GET_FINISHED](
        state: ILookUpState,
        action: IAction<NazioniModel[]>
    ): ILookUpState {
        const firstItem = "Z000";
        return {
            ...state,
            nazioni: action.payload!.sort((x, y) => {
                return x.key === firstItem ? -1 : y.key === firstItem ? 1 : 0;
            }),
        };
    }

    public [LookUpAction.REQUEST_LOOKUP_COMUNI_GET_BIRTH_PLACE_FINISHED](
        state: ILookUpState,
        action: IAction<ComuniModel[]>
    ): ILookUpState {
        return {
            ...state,
            comuniBirthPlace: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_LOOKUP_COMUNI_GET_RESIDENCE_PLACE_FINISHED](
        state: ILookUpState,
        action: IAction<ComuniModel[]>
    ): ILookUpState {
        return {
            ...state,
            comuniResidencePlace: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_LOOKUP_PRODUCT_TYPES_GET_FINISHED](
        state: ILookUpState,
        action: IAction<TipoProdottoModel[]>
    ): ILookUpState {
        return {
            ...state,
            productTypes: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_LOOKUP_ADDRESS_TYPES_GET_FINISHED](
        state: ILookUpState,
        action: IAction<TipoProdottoModel[]>
    ): ILookUpState {
        return {
            ...state,
            addressTypes: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_LOOKUP_SUB_LEVELS_GET_FINISHED](
        state: ILookUpState,
        action: IAction<SubLevelsModel[]>
    ): ILookUpState {
        return {
            ...state,
            subLevels: action.payload!,
        };
    }
    public [LookUpAction.REQUEST_LOOKUP_FILIALI_GET_FINISHED](
        state: ILookUpState,
        action: IAction<LookUpModel[]>
    ): ILookUpState {
        return {
            ...state,
            filiali: action.payload!,
        };
    }
    public [LookUpAction.REQUEST_LOOKUP_SEGNALAZIONI_GET_FINISHED](
        state: ILookUpState,
        action: IAction<LookUpModel[]>
    ): ILookUpState {
        return {
            ...state,
            segnalazioni: action.payload!,
        };
    }
    public [LookUpAction.REQUEST_LOOKUP_MOTIV_CAMBIO_TAN_GET_FINISHED](
        state: ILookUpState,
        action: IAction<LookUpModel[]>
    ): ILookUpState {
        return {
            ...state,
            motivCambioTan: action.payload!,
        };
    }
    public [LookUpAction.REQUEST_LOOKUP_STATO_PREV_GET_FINISHED](
        state: ILookUpState,
        action: IAction<LookUpModel[]>
    ): ILookUpState {
        return {
            ...state,
            statoPrev: action.payload!,
        };
    }
}
